import { render, staticRenderFns } from "./forgot-userdata.vue?vue&type=template&id=0dc1a30e&scoped=true"
import script from "./forgot-userdata.vue?vue&type=script&lang=js"
export * from "./forgot-userdata.vue?vue&type=script&lang=js"
import style0 from "./forgot-userdata.vue?vue&type=style&index=0&id=0dc1a30e&prod&lang=css"
import style1 from "./forgot-userdata.vue?vue&type=style&index=1&id=0dc1a30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1a30e",
  null
  
)

export default component.exports